export const MAX_CPI_THRESHOLD = 10;

export const HIGH_CPI_CONFIRMATION_MESSAGES = {
  survey:
    'You have entered a <span class="text-danger">HIGH CPI</span> of <span class="text-danger"><CURRENCY_SYMBOL><CPI></span>, please confirm that the value is entered exactly as you intend as all costs incurred will be billable.',
  project:
    'You have entered a <span class="text-danger">HIGH CPI</span> of <span class="text-danger"><CURRENCY_SYMBOL><CPI></span> in one or more surveys in this Survey Bundle. Please verify that this/these value/s is/are correct, as all incurred costs are fully billable.',
} as const;
